// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__263Tt","content":"styles_content__1rbmd","row":"styles_row__2wcPN","footer":"styles_footer__3Dvyd","phraseLength":"styles_phraseLength__324eX"};